import {CarecoApiContext} from "@/app-context/careco-api-context";
import {useContext} from "react";
import {MixpanelEventType, MixpanelSSOLaunchEvent, SSOApplication, SSOLaunchMethod} from "@/api/dto/mixpanel";
import {useMixpanel} from "@/hooks/useMixpanel";

export function useTreatmentConnection() {
  const { carecoApi } = useContext(CarecoApiContext);
  const { mixpanelEventProperties } = useMixpanel();

  const openTreatmentConnection =
      async (launchMethod: SSOLaunchMethod, baseUrl: string | undefined) => {
        window.open(baseUrl);

        const event : MixpanelSSOLaunchEvent = {
          eventName: MixpanelEventType.BIH_SSO_LAUNCHED,
          ...mixpanelEventProperties!,
          applicationName: SSOApplication.TREATMENT_CONNECTION,
          launchMethod
        };
        carecoApi?.postMixpanelEvent(event);
      };

  return {
    openTreatmentConnection,
  };
}
